<template>
    <div id="header-menu-background">
        <svg viewBox="0 0 100 100" preserveAspectRatio="none">
            <polygon id="menu-svg-polygon" points="0,0 0,0 0,100 0,100">
                <animate 
                    id="header_menu_background_open" 
                    attributeName="points" 
                    to="0,0 100,0 100,100 0,100" 
                    begin="indefinite" 
                    dur="200ms" 
                    fill="freeze" />
                <!--
                <animate 
                    id="header_menu_background_close" 
                    attributeName="points" 
                    from="0,0 100,0 100,100 0,100" 
                    to="0,0 0,0 0,100 0,100" 
                    begin="indefinite" 
                    dur="200ms" 
                    fill="freeze" />
                -->
                
            </polygon>
        </svg>
    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                svgContainer: null,
            }
        },

        mounted: function () {
            this.svgContainer = $( '#header-menu-background' );
            let openAnimation = document.getElementById( 'header_menu_background_open' );
            let closeAnimation = document.getElementById( 'header_menu_background_close' );

            if ( ! openAnimation.beginElement ) {
                this.svgContainer.find('svg').addClass('no-smil');
            }

            bus.$on( 'burger-menu-open', () => {

                if ( openAnimation.beginElement ) {
                    openAnimation.beginElement();
                }
                this.svgContainer.mouseleave(this.checkForClose);
            });

            bus.$on( 'burger-menu-close', () => {
                this.svgContainer.off( 'mouseleave' );
            });
        },

        methods: {
            checkForClose: function () {
                setTimeout( () => {
                    if ( $( '#burger-menu' ).is( ':hover' ) || $( '#navigation-bar-menu nav' ).is( ':hover' ) ) {
                        return;
                    }else{
                        bus.$emit( 'burger-menu-close' );
                    }
                }, 10);
            },
        }
    }
</script>

<style lang="scss">
    @import "./../../sass/variables";

    #navigation-bar-menu {
        
        #burger-menu.open {

            ~ #header-menu-background {
                transform: translate3d(0, 0, 0);
                transition-delay: 0s;
            }
        }

        > #header-menu-background {
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            width: 28rem;
            padding-right: 6rem;
            opacity: 1;
            transform: translate3d( -100%, 0, 0 );
            transition: transform .2s linear .2s;

            > svg {
                height: 100%;
                width: 100%;

                > polygon {
                    fill: $gray-lightest;
                }

                &.no-smil {
                    background-color: $gray-lightest;
                }
            }

            @media (max-width: 767px) {
                width: 24rem;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/HeaderMenuBackground.vue